import qs from 'qs';
import client from './client';

const targetUrl = '/api/v1/target';
const targetKpiUrl = '/api/v1/target/kpi';

// ==================== KPI 정의 ====================

/**
 * KPI 정의 목록 조회
 * @param {Object} searchData - { targetTyp, useYn }
 */
export const getKpiDefList = (searchData) => {
  const queryString = qs.stringify(searchData);
  return client.get(`${targetKpiUrl}/list?${queryString}`);
};

/**
 * KPI 정의 단건 조회
 */
export const getKpiDef = (kpiUuid) => {
  return client.get(`${targetKpiUrl}/${kpiUuid}`);
};

/**
 * KPI 정의 등록
 */
export const createKpiDef = (data) => {
  return client.post(targetKpiUrl, data);
};

/**
 * KPI 정의 수정
 */
export const updateKpiDef = (kpiUuid, data) => {
  return client.put(`${targetKpiUrl}/${kpiUuid}`, data);
};

/**
 * KPI 정의 삭제
 */
export const deleteKpiDef = (kpiUuid) => {
  return client.delete(`${targetKpiUrl}/${kpiUuid}`);
};


// ==================== 목표 관리 ====================

/**
 * 목표 헤더 목록 조회
 * @param {Object} searchData - { targetTyp, usrUuid, targetYear, dptUuid, hqUuid }
 */
export const getTargetList = (searchData) => {
  const queryString = qs.stringify(searchData);
  return client.get(`${targetUrl}/list?${queryString}`);
};

/**
 * 목표 단건 조회 (헤더 + 상세)
 */
export const getTarget = (targetUuid) => {
  return client.get(`${targetUrl}/${targetUuid}`);
};

/**
 * 사용자별 연간 목표 조회
 * @param {string} targetTyp - 목표 유형 (SALES/PRODUCTION/TECH...)
 * @param {string} usrUuid - 사용자 UUID
 * @param {string} targetYear - 연도
 */
export const getTargetByUser = (targetTyp, usrUuid, targetYear) => {
  return client.get(`${targetUrl}/user/${targetTyp}/${usrUuid}/${targetYear}`);
};

/**
 * 목표 저장 (월별 일괄)
 * @param {Object} data - { targetTyp, usrUuid, targetYear, monthlyTargets: [{ month, kpiValues: [{ kpiCd, targetVal }] }] }
 */
export const saveTarget = (data) => {
  return client.post(`${targetUrl}/save`, data);
};

/**
 * 팀별 목표 집계 조회
 */
export const getTargetSumByDept = (targetTyp, dptUuid, targetYear, targetMonth = null) => {
  let url = `${targetUrl}/sum/dept/${targetTyp}/${dptUuid}/${targetYear}`;
  if (targetMonth) {
    url += `?targetMonth=${targetMonth}`;
  }
  return client.get(url);
};

/**
 * 본부별 목표 집계 조회
 */
export const getTargetSumByHq = (targetTyp, hqUuid, targetYear, targetMonth = null) => {
  let url = `${targetUrl}/sum/hq/${targetTyp}/${hqUuid}/${targetYear}`;
  if (targetMonth) {
    url += `?targetMonth=${targetMonth}`;
  }
  return client.get(url);
};

/**
 * 회사 전체 목표 집계 조회
 */
export const getTargetSumByCompany = (targetTyp, companyUuid, targetYear, targetMonth = null) => {
  let url = `${targetUrl}/sum/company/${targetTyp}/${companyUuid}/${targetYear}`;
  if (targetMonth) {
    url += `?targetMonth=${targetMonth}`;
  }
  return client.get(url);
};

/**
 * 목표 삭제
 */
export const deleteTarget = (targetUuid) => {
  return client.delete(`${targetUrl}/${targetUuid}`);
};
